import React, { Component } from "react";
import Subjektif from "../form/Subjektif.js";
import Assesment from "../form/Assesment";
import Planning from "../form/Planning.js";
import CatenObjective from "./CatenObjective";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import CatenSubjektif from "./CatenSubjektif";

export default class Caten extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tahun_perkawinan: null,
      visitId: 1000,
      modules: [
        { id: "1", name: "Subjektif" },
        { id: "2", name: "Objektif" },
        { id: "3", name: "Assesment" },
        { id: "4", name: "Planning" },
      ],
      visible: false,
      detilPx: this.props.detilPx,
      tabIndex: 0,
    };
    this.nextTab = this.nextTab.bind(this);
    this.parentCallback = this.parentCallback.bind(this);
    this.onCatenSaved = this.onCatenSaved.bind(this);
  }
  parentCallback(data) {
    this.setState((prevState) => ({
      detilPx: {
        // object that we want to update
        ...prevState.detilPx, // keep all other key-value pairs
        [data.param]: data.data,
      },
    }));
    // console.log(data);
  }
  onCatenSaved(caten_id) {
    this.setState((prevState) => ({
      detilPx: {
        ...prevState.detilPx,
        caten_id: caten_id,
      },
    }));
  }

  nextTab() {
    const tabs = this.state.tabIndex;
    const tabIndex = tabs + 1;
    this.setState({ tabIndex: tabIndex });
  }

  render() {
    var patient = this.state.detilPx;
    return (
      <div>
        <div className="card">
          <div className="card-header">
            <div className="row align-items-center">
              <div className="col-8">
                <h4 className="h3 mb-0">Form Pemeriksaan Caten</h4>
              </div>
            </div>
          </div>
          <div className="card-body">
            <Tabs
              selectedIndex={this.state.tabIndex}
              onSelect={(tabIndex) => this.setState({ tabIndex })}
            >
              <TabList>
                <Tab id="Subjektif">Subjektif </Tab>
                <Tab id="Objektif">Objektif </Tab>
                <Tab id="Assesment">Assesment </Tab>
                <Tab id="Planning">Planning </Tab>
              </TabList>
              <TabPanel tabId="Subjektif">
                <CatenSubjektif
                  patient={patient}
                  parentCallback={this.parentCallback}
                  history={this.props.history}
                  nextTab={this.nextTab}
                  onCatenSaved={this.onCatenSaved}
                  onTahunPerkawinanChange={v => {
                    console.log({v})
                    this.setState({tahun_perkawinan: v})
                  }}
                />
              </TabPanel>
              <TabPanel tabId="Objektif">
                {/* <Objektif
                      patient={patient}
                      parentCallback={this.parentCallback}
                      history={this.props.history}
                      nextTab={this.nextTab}
                    /> */}
                <CatenObjective
                  patient={patient}
                  parentCallback={this.parentCallback}
                  history={this.props.history}
                  nextTab={this.nextTab}
                  tahunPerkawinan={this.state.tahun_perkawinan}
                />
              </TabPanel>
              <TabPanel tabId="Assesment">
                <Assesment
                  patient={patient}
                  parentCallback={this.parentCallback}
                  history={this.props.history}
                  nextTab={this.nextTab}
                />
              </TabPanel>
              <TabPanel tabId="Planning">
                <Planning
                  patient={patient}
                  parentCallback={this.parentCallback}
                  history={this.props.history}
                  nextTab={this.nextTab}
                />
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </div>
    );
  }
}
